import { render } from "./AliyunPromo.vue?vue&type=template&id=1baa463d&scoped=true"
import script from "./AliyunPromo.vue?vue&type=script&lang=js"
export * from "./AliyunPromo.vue?vue&type=script&lang=js"

import "./AliyunPromo.vue?vue&type=style&index=0&id=1baa463d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1baa463d"]])

export default __exports__